import { tv } from '@change/ds-utils';

export const CircleStyles = tv({
	base: 'bg-icon-inverse-disabled shrink-0 rounded-full',
	variants: {
		loading: {
			true: 'animate-pulse',
			false: '',
		},
		size: {
			xsmall: 'h-2 w-2',
			small: 'h-2.5 w-2.5',
			medium: 'h-5 w-5',
			large: 'h-6 w-6',
		},
	},
});
